module.exports = __webpack_public_path__ + "static/media/gray_animal_amphibians_6.cd4f9dbc.png";